import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../../Services/Api/ApiServices";

export const GetAllSU_ST_MRI_Nationality = createAsyncThunk(
  "DropDowns/GetAllSU_ST_MRI_Nationality",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/DropDowns/GetAllSU_ST_MRI_Nationality");

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetAllSU_NT_MRI_CountryOfRegistration = createAsyncThunk(
  "DropDowns/GetAllSU_NT_MRI_CountryOfRegistration",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/DropDowns/GetAllSU_NT_MRI_CountryOfRegistration");

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetAllSU_ST__MRI_TypeExperience = createAsyncThunk(
  "DropDowns/GetAllSU_ST__MRI_TypeExperience",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/DropDowns/GetAllSU_ST__MRI_TypeExperience");

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetAllSU_ST_MRI_Sector = createAsyncThunk(
  "DropDowns/GetAllSU_ST_MRI_Sector",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/DropDowns/GetAllSU_ST_MRI_Sector");

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetAllSU_ST_MRI_Governorate = createAsyncThunk(
  "DropDowns/GetAllSU_ST_MRI_Governorate",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/DropDowns/GetAllSU_ST_MRI_Governorate");

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetAllSU_ST_MRI_FoundationName = createAsyncThunk(
  "DropDowns/GetAllSU_ST_MRI_FoundationName",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(`api/DropDowns/GetAllSU_ST_MRI_FoundationName?sectorId=${param}`);

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetAllSU_ST_MRI_AcademicRank = createAsyncThunk(
  "DropDowns/GetAllSU_ST_MRI_AcademicRank",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/DropDowns/GetAllSU_ST_MRI_AcademicRank");

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetSU_ST_MRI_Years = createAsyncThunk(
  "DropDowns/GetSU_ST_MRI_Years",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/DropDowns/GetSU_ST_MRI_Years");

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetAllSU_ST_MRI_GovernorateByCountry = createAsyncThunk(
  "DropDowns/GetAllSU_ST_MRI_GovernorateByCountry",
  async (param, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/DropDowns/GetAllSU_ST_MRI_GovernorateByCountry",param);

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


export const GetAllSU_NT_MRI_CountryOfResidence = createAsyncThunk(
  "DropDowns/GetAllSU_NT_MRI_CountryOfResidence",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/DropDowns/GetAllSU_NT_MRI_CountryOfResidence");

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const DropDown = createSlice({
  name: "DropDown",
  initialState: {
    DropDownNationality: [],
    loadingDropDownNationality: false,
    errorDropDownNationality: null,

    DropDownCountryOfRegistration: [],
    loadingDropDownCountryOfRegistration: false,
    errorDropDownCountryOfRegistration: null,

    DropDownTypeExperience: [],
    loadingDropDownTypeExperience: false,
    errorDropDownTypeExperience: null,

    DropDownSU_ST_MRI_Sector: [],
    loadingDropDownSU_ST_MRI_Sector: false,
    errorDropDownSU_ST_MRI_Sector: null,

    DropDownSU_ST_MRI_Governorate: [],
    loadingDropDownSU_ST_MRI_Governorate: false,
    errorDropDownSU_ST_MRI_Governorate: null,

    DropDownSU_ST_MRI_FoundationName: [],
    loadingDropDownSU_ST_MRI_FoundationName: false,
    errorDropDownSU_ST_MRI_FoundationName: null,

    
    DropDownSU_ST_MRI_AcademicRank: [],
    loadingDropDownSU_ST_MRI_AcademicRank: false,
    errorDropDownSU_ST_MRI_AcademicRank: null,

    
    DropDownSU_ST_MRI_Years: [],
    loadingDropDownSU_ST_MRI_Years: false,
    errorDropDownSU_ST_MRI_Years: null,

     DropDownSU_NT_MRI_CountryOfResidence: [],
    loadingDropDownSU_NT_MRI_CountryOfResidence: false,
    errorDropDownSU_NT_MRI_CountryOfResidence: null,


     DropDownSU_ST_MRI_GovernorateByCountry: [],
    loadingDropDownSU_ST_MRI_GovernorateByCountry: false,
    errorDropDownSU_ST_MRI_GovernorateByCountry: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllSU_ST_MRI_Nationality.pending, (state, action) => {
        state.loadingDropDownNationality = true;
        state.DropDownNationality = action.payload;
        state.errorDropDownNationality = null;
      })
      .addCase(GetAllSU_ST_MRI_Nationality.fulfilled, (state, action) => {
        state.loadingDropDownNationality = false;
        state.DropDownNationality = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllSU_ST_MRI_Nationality.rejected, (state, action) => {
        state.loadingDropDownNationality = false;
        state.errorDropDownNationality = action.payload;
      })
      //---------------------------------------------------------
      .addCase(GetAllSU_NT_MRI_CountryOfRegistration.pending, (state, action) => {
        state.loadingDropDownCountryOfRegistration = true;
        state.DropDownCountryOfRegistration = action.payload;
        state.errorDropDownCountryOfRegistration = null;
      })
      .addCase(GetAllSU_NT_MRI_CountryOfRegistration.fulfilled, (state, action) => {
        state.loadingDropDownCountryOfRegistration = false;
        state.DropDownCountryOfRegistration = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllSU_NT_MRI_CountryOfRegistration.rejected, (state, action) => {
        state.loadingDropDownCountryOfRegistration = false;
        state.errorDropDownCountryOfRegistration = action.payload;
      })
       //---------------------------------------------------------
       .addCase(GetAllSU_ST__MRI_TypeExperience.pending, (state, action) => {
        state.loadingDropDownTypeExperience = true;
        state.DropDownTypeExperience = action.payload;
        state.errorDropDownTypeExperience = null;
      })
      .addCase(GetAllSU_ST__MRI_TypeExperience.fulfilled, (state, action) => {
        state.loadingDropDownTypeExperience = false;
        state.DropDownTypeExperience = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllSU_ST__MRI_TypeExperience.rejected, (state, action) => {
        state.loadingDropDownTypeExperience = false;
        state.errorDropDownTypeExperience = action.payload;
      })

       //---------------------------------------------------------
       .addCase(GetAllSU_ST_MRI_Sector.pending, (state, action) => {
        state.loadingDropDownSU_ST_MRI_Sector = true;
        state.DropDownSU_ST_MRI_Sector = action.payload;
        state.errorDropDownSU_ST_MRI_Sector = null;
      })
      .addCase(GetAllSU_ST_MRI_Sector.fulfilled, (state, action) => {
        state.loadingDropDownSU_ST_MRI_Sector = false;
        state.DropDownSU_ST_MRI_Sector = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllSU_ST_MRI_Sector.rejected, (state, action) => {
        state.loadingDropDownSU_ST_MRI_Sector = false;
        state.errorDropDownSU_ST_MRI_Sector = action.payload;
      })
      //---------------------------------------------------------
      .addCase(GetAllSU_ST_MRI_Governorate.pending, (state, action) => {
        state.loadingDropDownSU_ST_MRI_Governorate = true;
        state.DropDownSU_ST_MRI_Governorate = action.payload;
        state.errorDropDownSU_ST_MRI_Governorate = null;
      })
      .addCase(GetAllSU_ST_MRI_Governorate.fulfilled, (state, action) => {
        state.loadingDropDownSU_ST_MRI_Governorate = false;
        state.DropDownSU_ST_MRI_Governorate = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllSU_ST_MRI_Governorate.rejected, (state, action) => {
        state.loadingDropDownSU_ST_MRI_Governorate = false;
        state.errorDropDownSU_ST_MRI_Governorate = action.payload;
      })
        //---------------------------------------------------------
        .addCase(GetAllSU_ST_MRI_FoundationName.pending, (state, action) => {
          state.loadingDropDownSU_ST_MRI_FoundationName = true;
          state.DropDownSU_ST_MRI_FoundationName = action.payload;
          state.errorDropDownSU_ST_MRI_FoundationName = null;
        })
        .addCase(GetAllSU_ST_MRI_FoundationName.fulfilled, (state, action) => {
          state.loadingDropDownSU_ST_MRI_FoundationName = false;
          state.DropDownSU_ST_MRI_FoundationName = action.payload; // Assuming payload has the desired data
        })
        .addCase(GetAllSU_ST_MRI_FoundationName.rejected, (state, action) => {
          state.loadingDropDownSU_ST_MRI_FoundationName = false;
          state.errorDropDownSU_ST_MRI_FoundationName = action.payload;
        })

          //---------------------------------------------------------
          .addCase(GetAllSU_ST_MRI_AcademicRank.pending, (state, action) => {
            state.loadingDropDownSU_ST_MRI_AcademicRank = true;
            state.DropDownSU_ST_MRI_AcademicRank = action.payload;
            state.errorDropDownSU_ST_MRI_AcademicRank = null;
          })
          .addCase(GetAllSU_ST_MRI_AcademicRank.fulfilled, (state, action) => {
            state.loadingDropDownSU_ST_MRI_AcademicRank = false;
            state.DropDownSU_ST_MRI_AcademicRank = action.payload; // Assuming payload has the desired data
          })
          .addCase(GetAllSU_ST_MRI_AcademicRank.rejected, (state, action) => {
            state.loadingDropDownSU_ST_MRI_AcademicRank = false;
            state.errorDropDownSU_ST_MRI_AcademicRank = action.payload;
          })

           //---------------------------------------------------------
           .addCase(GetSU_ST_MRI_Years.pending, (state, action) => {
            state.loadingDropDownSU_ST_MRI_Years = true;
            state.DropDownSU_ST_MRI_Years = action.payload;
            state.errorDropDownSU_ST_MRI_Years = null;
          })
          .addCase(GetSU_ST_MRI_Years.fulfilled, (state, action) => {
            state.loadingDropDownSU_ST_MRI_Years = false;
            state.DropDownSU_ST_MRI_Years = action.payload; // Assuming payload has the desired data
          })
          .addCase(GetSU_ST_MRI_Years.rejected, (state, action) => {
            state.loadingDropDownSU_ST_MRI_Years = false;
            state.errorDropDownSU_ST_MRI_Years = action.payload;
          })
           //---------------------------------------------------------
           .addCase(GetAllSU_ST_MRI_GovernorateByCountry.pending, (state, action) => {
            state.loadingDropDownSU_ST_MRI_GovernorateByCountry = true;
            state.DropDownSU_ST_MRI_GovernorateByCountry = action.payload;
            state.errorDropDownSU_ST_MRI_GovernorateByCountry = null;
          })
          .addCase(GetAllSU_ST_MRI_GovernorateByCountry.fulfilled, (state, action) => {
            state.loadingDropDownSU_ST_MRI_GovernorateByCountry = false;
            state.DropDownSU_ST_MRI_GovernorateByCountry = action.payload; // Assuming payload has the desired data
          })
          .addCase(GetAllSU_ST_MRI_GovernorateByCountry.rejected, (state, action) => {
            state.loadingDropDownSU_ST_MRI_GovernorateByCountry = false;
            state.errorDropDownSU_ST_MRI_GovernorateByCountry = action.payload;
          })
           //---------------------------------------------------------
           .addCase(GetAllSU_NT_MRI_CountryOfResidence.pending, (state, action) => {
            state.loadingDropDownSU_NT_MRI_CountryOfResidence = true;
            state.DropDownSU_NT_MRI_CountryOfResidence = action.payload;
            state.errorDropDownSU_NT_MRI_CountryOfResidence = null;
          })
          .addCase(GetAllSU_NT_MRI_CountryOfResidence.fulfilled, (state, action) => {
            state.loadingDropDownSU_NT_MRI_CountryOfResidence = false;
            state.DropDownSU_NT_MRI_CountryOfResidence = action.payload; // Assuming payload has the desired data
          })
          .addCase(GetAllSU_NT_MRI_CountryOfResidence.rejected, (state, action) => {
            state.loadingDropDownSU_NT_MRI_CountryOfResidence = false;
            state.errorDropDownSU_NT_MRI_CountryOfResidence = action.payload;
          })
      ;
  },
});

export default DropDown.reducer;
